var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"have-account"},[_c('p',[_vm._v(" "+_vm._s(_vm.haveAccountData.haveAccountTitle)+" "),_c('span',[_c('router-link',{attrs:{"to":_vm.haveAccountData.haveAccountLink}},[_vm._v(" "+_vm._s(_vm.haveAccountData.haveAccountButtonText)+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }